import { supabase } from '@/core/database/supabase';
import type { ProjectNewForm } from '../types/projectNew.types';

export const projectNewService = {
  async createProject(companyId: string, form: ProjectNewForm): Promise<string> {
    const metadata = {
      thumbnail: form.thumbnail,
      attachments: form.attachments,
      teamIds: form.teamIds,
      managementUnit: form.managementUnit,
      duration: form.duration,
      contractType: form.contractType,
      priority: form.priority,
      note: form.note,
    };

    const finalDescription = `${form.description}\n\n[METADATA]: ${JSON.stringify(metadata)}`;

    const { data, error } = await supabase
      .from('projects')
      .insert({
        company_id: companyId,
        code: form.code,
        name: form.name,
        client_name: form.clientName,
        location: form.location,
        project_type: form.projectType,
        status_code: form.statusCode,
        start_date: form.startDate || null,
        end_date: form.endDate || null,
        contract_amount: form.contract_amount,
        budget_amount: form.budget_amount,
        description: finalDescription, // Save metadata inside description
        pm_user_id: form.pmUserId || null,
        site_manager_user_id: form.siteManagerUserId || null,
      })
      .select('id')
      .single();

    if (error) throw error;
    return data.id;
  },

  async getManagers(companyId: string) {
    const { data, error } = await supabase
      .from('user_profiles')
      .select(`
        id, 
        full_name,
        user_roles!inner(role_code)
      `)
      .eq('company_id', companyId)
      .neq('user_roles.role_code', 'employee');

    if (error) {
      console.error('[projectNewService] getManagers error:', error);
      return [];
    }

    // Deduplicate in case a user has multiple roles (though supabase inner join returns flat if used correctly, or array if multiple)
    // To be safe, we just map it out.
    const uniqueUsers = Array.from(new Map(data?.map(u => [u.id, u])).values());
    
    return uniqueUsers;
  }
};
